import { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import "../streamcss/invitation.css";
import { useSelector } from "react-redux";



const InvitationModal = ({ title, message, onAllow, onDeny }) => {

  const theme = useSelector((state) => state?.donation?.theme || "");

 useEffect(() => {
    (async () => {
      await microsoftTeams.app.initialize();
      // Tell Teams: “I’m ready now”
      microsoftTeams.app.notifySuccess();
    })();
  }, []);

   
  return (
    <div className={"modal-overlay " + (theme || "")}>
      <div className={"modal-container " + (theme || "")}>
        <div className="modal-header">
          <span className="modal-title">{title}</span>
        </div>
        <div className="modal-body">
          <p className={"modal-message " + (theme || "")}>{"Givent wants to send an invitation to all meeting participants"}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-button allow-button" onClick={onAllow}>
            Allow
          </button>
          <button className="modal-button deny-button" onClick={onDeny}>
            Don't allow
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationModal;
